import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import clsx from 'clsx';
import i18n from '@pureartisan/simple-i18n';
import InteractiveScale from './InteractiveScale';

var FilterSeries = function FilterSeries(_ref) {
  var props = _extends({}, _ref); // Get all of the items in the metrics array with matching tab node.


  var filters = props.metrics.filter(function (m) {
    return m.tab === props.tab && m.tab_level === 1;
  }); // Alphabetize them by title

  filters.sort(function (a, b) {
    return a.order - b.order;
  });

  if (filters && filters.length > 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h5", null, i18n.translate('UI_MAP_FILTERS_INDICATORS')), /*#__PURE__*/React.createElement("div", {
      className: "filter-panel-filter-series"
    }, filters.map(function (f) {
      return /*#__PURE__*/React.createElement("div", {
        className: "filter",
        key: f.id
      }, /*#__PURE__*/React.createElement("h6", null, i18n.translate(f.title)), /*#__PURE__*/React.createElement(InteractiveScale, {
        metric: f
      }));
    })));
  } else {
    return '';
  }
};

FilterSeries.defaultProps = {
  tab: 'cri',
  metrics: []
};
export default FilterSeries;